import {type AcceptableDocument, RichDiv} from '../../rich-text';
import styles from './NotFoundPage.module.scss';

export interface BannerProps {
  title?: string;
  src?: string;
}

export interface NotFoundPageProps {
  title: AcceptableDocument;
  description: AcceptableDocument;
  showBanner?: boolean;
  banner?: BannerProps;
}

export const NotFoundPage: React.FC<NotFoundPageProps> = ({
  banner,
  title,
  description,
  showBanner = false,
}) => {
  return (
    <div
      data-testid="not-found-container"
      className={styles.notFoundContainer}
    >
      <div className={styles.columnLeft}>
        <h2 className="mt-6 text-4xl font-extrabold text-gray-900">
          <RichDiv>{title}</RichDiv>
        </h2>
        <div className="prose max-w-none">
          <RichDiv>{description}</RichDiv>
        </div>
      </div>
      {showBanner && (
        <div
          data-testid="not-found-banner"
          className={styles.columnRight}
        >
          <img
            className="column-right"
            src={banner?.src}
            alt={banner?.title}
          />
        </div>
      )}
    </div>
  );
};
